import React, { useState } from 'react';

import { Box, Button, Typography } from '@mui/material';

import PermissionedComponent from '~/components/Common/PermissionedComponent';
import {
  ROLE_ADMIN_USER,
  ROLE_EMPLOYEE_USER,
  ROLE_ICS_STORE_TEAM,
} from '~/consts/roles';

import { formatDateWeekDayShortMonth } from '~/services/TimeService';
import SpoofUserDialog from '../Common/SpoofUserDialog';

const isNewDay = (idx: number, date: string, recentUsers: Array<any>) => {
  if (idx === 0) {
    return true;
  }
  const previousDate = new Date(recentUsers[idx - 1].date);
  const currentDate = new Date(date);
  return previousDate.toDateString() !== currentDate.toDateString();
};

export default function RecentlyViewedPurchases() {
  const savedOrders = localStorage.getItem('recentlyViewedOrders');
  const recentOrders = savedOrders ? JSON.parse(savedOrders) : [];
  const [spoofUser, setSpoofUser] = useState<{ id: string; label: string; orderUuid?: string } | null>(null);

  return (
    <Box>
      <Typography variant="h4">Recently viewed orders</Typography>
      {recentOrders.map(({ order, date, id }, idx) => (
        <Box key={id}>
          {isNewDay(idx, date, recentOrders) && (
            <Typography component="pre" variant="body2" sx={{ marginTop: 2, fontFamily: 'monospace' }}>
              {formatDateWeekDayShortMonth(date)}
            </Typography>
          )}
          <a href={`/purchases/${id}`}>view</a>&nbsp;
          <PermissionedComponent requiredRoles={[ROLE_ADMIN_USER, ROLE_EMPLOYEE_USER, ROLE_ICS_STORE_TEAM]}>
            <Button size="small" onClick={() => setSpoofUser({ id: order.fk_customer_id, label: order.customer_email, orderUuid: id })}>
              spoof
            </Button>
          </PermissionedComponent>{' '}
          {order.customer_full_name} {order.currency_code} {order.total} on{' '}
          {formatDateWeekDayShortMonth(order.created_at)}
        </Box>
      ))}
      {spoofUser && (
        <SpoofUserDialog
          open={Boolean(spoofUser)}
          onClose={() => setSpoofUser(null)}
          userId={spoofUser!.id}
          userLabel={spoofUser!.label}
          orderUuid={spoofUser!.orderUuid}
        />
      )}
    </Box>
  );
}
